export const LOCALES_FOR_CURRENCIES = {
  NOK: () => import('@angular/common/locales/de'),
  DKK: () => import('@angular/common/locales/da'),
  SEK: () => import('@angular/common/locales/se'),
  EUR: () => import('@angular/common/locales/de'),
};
